var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TermGraph',_vm._b({attrs:{"request-status":_vm.requestStatus,"graph-data":_vm.graphData,"title":_vm.title,"item-id":_vm.itemId,"is-modal":_vm.isModal},on:{"reload":_vm.getData}},'TermGraph',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }